import React, { useEffect, useRef } from "react";
import { getCokkie } from "../../login/Login";


const EvaluationProgressStream = ({ evalId, status, onCount, onDone }) => {
  const workerRef = useRef(null);

  // Keep latest callbacks without re-triggering effect
  const onCountRef = useRef(onCount);
  const onDoneRef = useRef(onDone);

  useEffect(() => {
    onCountRef.current = onCount;
  }, [onCount]);

  useEffect(() => {
    onDoneRef.current = onDone;
  }, [onDone]);

  // Track which evaluation we already started the worker for
  const startedKeyRef = useRef(null);

  const stopWorker = () => {
    if (workerRef.current) {
      workerRef.current.terminate();
      workerRef.current = null;
    }
    startedKeyRef.current = null;
  };

  useEffect(() => {
    // Only run while evaluating
    const isActive = status === "Evaluating" || status === "Paused";
    if (!evalId || !isActive) {
      stopWorker();
      return;
    }

    // Start worker only once for this evalId while evaluating
    const startKey = `${evalId}-${status}`;
    if (startedKeyRef.current === startKey && workerRef.current) {
      return; // ✅ already running, do not restart
    }

    // If something exists (switching evalId), stop and restart
    stopWorker();
    startedKeyRef.current = startKey;

    const token = getCokkie("jwtToken");
    const url = `${window.ENV.API_URL}/evaluations?filters={"_id":"${evalId}"}&section=evaluation_progress`;

    // ✅ Adjust the relative path to match your project structure
    const workerUrl = new URL("../../../worker/evaluationProgressWorker.js", import.meta.url);
    const worker = new Worker(workerUrl, { type: "module" });
    workerRef.current = worker;

    worker.postMessage({ url, token });

    // worker.onmessage = (e) => {
    //   const { type, count } = e.data || {};

    //   if (type === "count") {
    //     onCountRef.current?.(count);
    //   } else if (type === "complete") {
    //     onDoneRef.current?.();
    //     stopWorker(); // ✅ terminate once "Status Done" arrives
    //   }
    // };
    worker.onmessage = (e) => {
  const { type, count, total } = e.data || {};

  if (type === "count") {
    onCountRef.current?.(count, total);
  } else if (type === "complete") {
    onDoneRef.current?.();
    stopWorker();
  }
};

    worker.onerror = () => {
      stopWorker();
    };

    // Cleanup on unmount / evalId change / status change
    return () => {
      stopWorker();
    };
  }, [evalId, status]); // ✅ IMPORTANT: only depends on evalId + status

  return <div style={{ display: "none" }} />;
};

export default EvaluationProgressStream;